module.exports = "<div class=\"demo-footer text-center\">\n  <h6>&copy; 2019, made with <i class=\"fa fa-heart heart\"></i> by Planet Musicians</h6>\n</div>\n"